module.exports = __webpack_public_path__ + "fonts/Inter-ExtraLight-slnt=0.909744bb.ttf";